'use es6';

import { CSS as FOLDER_ASSET_TYPE_CSS, JS, TEMPLATE } from 'DesignData/enums/FolderAssetTypes';
import { MD } from 'DesignData/enums/RawAssetFileTypes';
export default Object.freeze({
  [FOLDER_ASSET_TYPE_CSS]: 'css',
  [JS]: 'js',
  [TEMPLATE]: 'html',
  [MD]: 'md'
});